import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Card,
  CardBody,
  SimpleGrid,
  Button,
  Icon,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { ArrowRight, CalendarBlank } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { PageMeta } from '../components/PageMeta'

// This will come from Firestore later
const timelineItems = [
  {
    id: 'narodziny',
    year: 1974,
    title: 'Narodziny Kostki Rubika',
    description: 'Węgierski profesor Ernő Rubik tworzy pierwszy prototyp kostki, która zrewolucjonizuje świat łamigłówek.',
    slug: 'narodziny-kostki-rubika',
  },
  {
    id: 'fenomen',
    year: 1980,
    title: 'Fenomen Kostki',
    description: 'Kostka Rubika podbija świat, stając się globalnym fenomenem kulturowym i sportowym.',
    slug: 'fenomen-kostki',
  },
  {
    id: 'matematyka',
    year: 2010,
    title: 'Matematyka Kostki',
    description: 'Google pomaga rozwiązać zagadkę "God\'s Number" i odkryć matematyczne tajemnice kostki.',
    slug: 'matematyka-kostki',
  },
  {
    id: 'speedcubing',
    year: 2020,
    title: 'Speedcubing i Biały Krzyż',
    description: 'Współczesne metody układania i rozwój profesjonalnego speedcubingu.',
    slug: 'speedcubing',
  },
  {
    id: 'znak-towarowy',
    year: 2016,
    title: 'Znak Towarowy "Rubik\'s"',
    description: 'Ewolucja znaku towarowego i pojawienie się nowych marek na rynku speedcubingu.',
    slug: 'znak-towarowy',
  },
  {
    id: 'rewolucja',
    year: 2022,
    title: 'Rewolucja w Mechanice',
    description: 'Najnowsze technologie jak Ballcore i Maglev rewolucjonizują konstrukcję kostek.',
    slug: 'rewolucja-w-mechanice',
  },
]

const History = () => {
  const { t } = useTranslation()
  const timelineBg = useColorModeValue('gray.100', 'gray.700')
  const timelineColor = useColorModeValue('brand.500', 'brand.200')
  const cardHoverBg = useColorModeValue('gray.50', 'gray.700')

  return (
    <>
      <PageMeta
        title="history.title"
        description="history.description"
      />
      
      <Container maxW="container.xl" py={8}>
        <VStack spacing={8} align="stretch">
          {/* Hero Section */}
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl">{t('history.title')}</Heading>
            <Text fontSize="xl" color="text.muted" maxW="2xl">
              {t('history.subtitle')}
            </Text>
          </VStack>

          {/* Timeline */}
          <Box position="relative" py={8}>
            {/* Timeline Line */}
            <Box
              position="absolute"
              left="50%"
              top={0}
              bottom={0}
              width="2px"
              bg={timelineBg}
              transform="translateX(-50%)"
            />

            {/* Timeline Items */}
            <VStack spacing={8} position="relative">
              {timelineItems.map((item, index) => (
                <Box
                  key={item.id}
                  width="100%"
                  position="relative"
                  _before={{
                    content: '""',
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: '16px',
                    height: '16px',
                    bg: timelineColor,
                    borderRadius: 'full',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                  }}
                >
                  <SimpleGrid
                    columns={2}
                    spacing={8}
                    width="100%"
                    sx={{
                      '& > *:nth-of-type(odd)': {
                        textAlign: 'right',
                        paddingRight: '2rem',
                      },
                      '& > *:nth-of-type(even)': {
                        textAlign: 'left',
                        paddingLeft: '2rem',
                      },
                    }}
                  >
                    {index % 2 === 0 ? (
                      <>
                        <Card
                          as={RouterLink}
                          to={`/history/${item.slug}`}
                          variant="outline"
                          _hover={{
                            textDecoration: 'none',
                            bg: cardHoverBg,
                            transform: 'translateY(-2px)',
                          }}
                          transition="all 0.2s"
                        >
                          <CardBody>
                            <VStack align="flex-end" spacing={2}>
                              <Box color={timelineColor}>
                                <Icon as={CalendarBlank} weight="bold" mr={2} />
                                {item.year}
                              </Box>
                              <Heading size="md">{item.title}</Heading>
                              <Text color="text.muted">{item.description}</Text>
                              <Button
                                rightIcon={<ArrowRight />}
                                variant="ghost"
                                size="sm"
                                colorScheme="brand"
                              >
                                {t('common.readMore')}
                              </Button>
                            </VStack>
                          </CardBody>
                        </Card>
                        <Box />
                      </>
                    ) : (
                      <>
                        <Box />
                        <Card
                          as={RouterLink}
                          to={`/history/${item.slug}`}
                          variant="outline"
                          _hover={{
                            textDecoration: 'none',
                            bg: cardHoverBg,
                            transform: 'translateY(-2px)',
                          }}
                          transition="all 0.2s"
                        >
                          <CardBody>
                            <VStack align="flex-start" spacing={2}>
                              <Box color={timelineColor}>
                                <Icon as={CalendarBlank} weight="bold" mr={2} />
                                {item.year}
                              </Box>
                              <Heading size="md">{item.title}</Heading>
                              <Text color="text.muted">{item.description}</Text>
                              <Button
                                rightIcon={<ArrowRight />}
                                variant="ghost"
                                size="sm"
                                colorScheme="brand"
                              >
                                {t('common.readMore')}
                              </Button>
                            </VStack>
                          </CardBody>
                        </Card>
                      </>
                    )}
                  </SimpleGrid>
                </Box>
              ))}
            </VStack>
          </Box>
        </VStack>
      </Container>
    </>
  )
}

export default History 